import React, { useState, useEffect } from 'react'
import { RadioGroup } from '../../../ui'
import { useStore } from '../../../StateProvider'
import { map, isNil } from 'ramda'
import { getUserValue } from '../utils'

const getTypedValue = (type, value) => {
  if (type === 'number') {
    return +value
  } else if (type === 'boolean') {
    return JSON.parse(value)
  }
  return value
}

const ExternalRadioGroupDependent = ({
  list,
  validValue,
  label,
  name,
  defaultValue,
  valueType,
  jointOnly
}) => {
  const [value, setValue] = useState('')
  const [isValid, setIsValid] = useState(false)
  const [isVisible, setIsVisible] = useState(false)
  const [{ user, form: { accId } }, dispatch] = useStore()
  const userValue = getUserValue(accId, user, name)

  useEffect(() => {
    const isVisible = jointOnly && accId > 0
    setIsVisible(isVisible)
    if (isVisible) {
      dispatch({ type: 'addValidationFld', name })
    } else {
      dispatch({ type: 'removeValidationFld', name })
      dispatch({ type: 'removeFieldValue', name })
      setValue('')
      setIsValid(false)
    }
  }, [jointOnly, accId])

  useEffect(() => {
    if (!isVisible) return
    const newValue = !isNil(userValue) ? userValue.toString() : defaultValue
    if (newValue) {
      presetValue(newValue)
    }
  }, [defaultValue, name, userValue, isVisible])

  const presetValue = (value) => {
    const isValid = validValue ? value === validValue : true
    setValue(value)
    setIsValid(isValid)
    dispatch({ type: 'setExtFieldValue', name, value: getTypedValue(valueType, value) })
    dispatch({ type: 'setValidationFld', name, value: isValid })
  }

  const onChange = ({ currentTarget: { value } }) => {
    presetValue(value)
  }

  return isVisible ? (
    <RadioGroup
      name={name}
      onChange={onChange}
      value={value}
      list={list}
      label={label}
      isValid={isValid}
    />
  ) : null
}

const getExternalRadioGroupDependentFields = map(radioButtonField => {
  return (
    <ExternalRadioGroupDependent
      {...radioButtonField}
      key={radioButtonField.name}
      label={`generatedField.${radioButtonField.i18n}`}
      valueType='boolean'
    />
  )
})

export { ExternalRadioGroupDependent, getExternalRadioGroupDependentFields }
